





























































import { Component, Vue, Watch } from 'vue-property-decorator';
import Loading from 'vue-loading-overlay';
import orderService from '@/services/order-service';
import { eventBus } from '@/main';
import { APP_CONFIG } from '@/config/app-config';
import { NotificationModel } from '@/models/notification';

import commonServices from '@/services/common-services';

@Component({
    components: {
        Loading
    }
})
export default class Notification extends Vue {
    private pageSettings = {
        rowPerPage: 10,
        pageSize: 3,
        pageIndex: 1,
        total: 0,
    };
    private listNotification: NotificationModel[] = [];
    private isLoading = false;
    private stopLoad = false;
    private depositType = APP_CONFIG.ORDER_TYPE.deposit;
    private status = false;

    @Watch('status', { immediate: true, deep: true })
    private async watchStatus() {
        this.pageSettings.pageIndex = 1;
        this.listNotification = [];
        this.loadNotification();
    }

    private buildFilter() {
        if (this.status === true) {return [];}
        if (this.status === false) {return [{ column: 'Status', value: [0,2], condition: 'in' }];}
        return [];
    }

    private async loadNotification() {
        this.isLoading = true;
        const filter = this.buildFilter();
        const result = await commonServices.getNotification(this.pageSettings.pageIndex, this.pageSettings.rowPerPage, filter, false);
        if (result && result.status === 200 && result.data.status === 200) {
            for (const item of result.data.data) {
                const notification = new NotificationModel();
                notification.createdDate = item.CreatedDate;
                notification.id = item.ID;
                notification.isBuy = item.IsBuy;
                notification.mainOrder = item.MainOrder;
                notification.message = item.Message;
                notification.orderId = item.OrderID;
                notification.orderType = item.OrderType;
                notification.receivedId = item.ReceivedID;
                notification.status = item.Status;

                this.listNotification.push(notification);
            }

            if (result.data.data.length === 0) {
                this.stopLoad = true;
            } else {
                this.stopLoad = false;
            }
        }
        this.isLoading = false;
    }

    public isQuotationNotif(notif: NotificationModel): boolean {
        if (!notif || notif.orderType == 4) return false;
        return notif.orderType == 100 || notif.orderType == 7 || notif.orderType == 8 ||
            Boolean(notif.message && notif.message.toLowerCase().includes('báo giá'));
    }

    public getNotificationHref(notif: NotificationModel): string {
        if (!notif || !notif.orderId) return 'javascript:void(0)';
        if (this.isQuotationNotif(notif)) {
            const routeData = this.$router.resolve({
                name: 'quotation-detail',
                params: { id: notif.orderId.toString() },
                query: { tab: 'chat' }
            });
            return routeData.href;
        }
        return 'javascript:void(0)';
    }

    private async onReadNotification(notif: NotificationModel, event?: MouseEvent) {
        try {
            if (notif.status === 0 || notif.status === 2) {
                notif.status = 1;
                commonServices.updateStatusNotification(notif.id, { Status: 1 }).then(() => {
                    eventBus.$emit(APP_CONFIG.eventBusAction.reloadNotification, null);
                }).catch(() => {});
            }

            if (!notif.orderId) {
                if (event) event.preventDefault();
                return;
            }

            if (this.isQuotationNotif(notif)) {
                // If not triggered from a native link click with target="_blank", open window manually
                if (!event) {
                    const routeData = this.$router.resolve({
                        name: 'quotation-detail',
                        params: { id: notif.orderId.toString() },
                        query: { tab: 'chat' }
                    });
                    window.open(routeData.href, '_blank');
                }
                return;
            }

            if (event) {
                event.preventDefault();
            }

            if (notif.orderType == APP_CONFIG.ORDER_TYPE.deposit) {
                this.$router.push({ name: 'deposit-detail', params: { id: notif.orderId.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.orderType == 6) {
                this.$router.push({ name: 'payauthority-detail', params: { id: notif.orderId.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.orderType == 5) {
                this.$router.push({ name: 'payservice-detail', params: { id: notif.orderId.toString() } }).catch(() => {
                    return false;
                });
            } else if(notif.orderType == 4) {
                this.isLoading = true;
                const result = await orderService.getComplainById(notif.orderId);
                this.isLoading = false;
                if (result && result.status === 200 && result.data.status === 200) {
                    let complain = result.data.data;
                    if(complain.OrderType == 1) {
                        this.$router.push({ name: 'detail-order-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                    else if (complain.orderType == 2) {
                        this.$router.push({ name: 'detail-deposit-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                    else if(complain.orderType == 3) {
                        this.$router.push({ name: 'detail-payauthority-complain', params: { orderId: complain.OrderID, complainId: complain.ID, orderType: complain.OrderType } });
                    }
                    else if(complain.orderType == 5 || complain.OrderType == 5) {
                        const routeData = this.$router.resolve({ name: 'detail-quotation-complain', params: { orderId: complain.OrderID.toString(), complainId: complain.ID.toString(), orderType: '5' } });
                        window.open(routeData.href, '_blank');
                    }
                }
            } else {
                this.$router.push({ name: 'order-detail', params: { orderId: notif.orderId.toString() } }).catch(() => {
                    return false;
                });
            }
        } catch {
            this.isLoading = false;
            return false;
        }
    }

    private async loadMore() {
        this.pageSettings.pageIndex++;
        this.loadNotification();
    }
}
